import i18nextConfig from '../../../next-i18next.config'
import { Language } from '../types'

export const getLocalePathFromPathname = (
  pathname: string,
  locale: string,
): string => {
  const isDefault = locale === process.env.NEXT_PUBLIC_DEFAULT_LOCALE

  let path: string
  if (pathname.includes('[locale]')) {
    path = isDefault
      ? pathname.replace('/[locale]', '')
      : pathname.replace('[locale]', locale)
  } else {
    path = isDefault ? pathname : `/${locale}${pathname}`
  }

  if (!path || path === '/') return '/'

  // Ensure a single trailing slash (trailingSlash: true) without producing
  // doubled slashes when the input already ends with one.
  return `${path}/`.replace(/\/{2,}/g, '/')
}

export const extractLocaleFromURL = (path: string) => {
  let locale = path.split('/')[1]
  if (!i18nextConfig.i18n.locales.map((l) => l).includes(locale)) {
    locale = i18nextConfig.i18n.defaultLocale
  }

  return locale
}

export const getLocaleAppBaseUrl = (locale: string, route?: string): string => {
  const baseUrl = process.env.NEXT_PUBLIC_APP_BASEURL || ''
  const localePath = Language.en === locale ? '' : `/${locale}`
  const routePath = route ? `/${route}` : ''

  let fullPath = `${baseUrl}${localePath}${routePath}`

  if (route && locale && !fullPath.endsWith('/')) {
    fullPath += '/'
  }

  return fullPath
}

export const getFullPath = (path: string, locale: string): string => {
  if (locale === process.env.NEXT_PUBLIC_DEFAULT_LOCALE) {
    return process.env.NEXT_PUBLIC_BASEURL + (path ? path : '')
  }
  return process.env.NEXT_PUBLIC_BASEURL + '/' + locale + (path ? path : '/')
}

export const getCanonicalPath = (path: string): string => {
  return path.split('?')[0]
}
